import { render, staticRenderFns } from "./rule4.vue?vue&type=template&id=65ee9ffa&scoped=true"
import script from "./rule4.vue?vue&type=script&lang=js"
export * from "./rule4.vue?vue&type=script&lang=js"
import style0 from "./rule4.vue?vue&type=style&index=0&id=65ee9ffa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ee9ffa",
  null
  
)

export default component.exports